import { Accordion, AccordionSummary, AccordionDetails } from './sidebar-accordion'
import { usePageEditorContext } from '../contexts/page-editor.context'
import { CategoryListEdit } from './category-list-edit'
import { reportDataSetService } from './report-data-set.service'

export const FilterEditAccordion = function ({ block }) {
  const pageEditorContext = usePageEditorContext() || {}
  const page = pageEditorContext.page

  return (
    <Accordion square data-qa="filter-edit-accordion">
      <AccordionSummary data-qa="filter-accordion-trigger">
        Filter
      </AccordionSummary>
      <AccordionDetails>
        <div className="field-grid">
          <div className="full-width-field">
            <CategoryListEdit
              size="medium"
              categoryLabel="Filter"
              listLabel={page && page.isInteractive ? 'Filter Option Labels' : 'Filter Value'}
              isSingleSelection={page && !page.isInteractive}
              categories={reportDataSetService.getFilterOptionLabels(block).filter((field) => !field.isSplitChartFilter)}
              onChange={(updatedSubgroups) => {
                // Merge split chart filter back in before running update.
                // Otherwise, the split chart filter gets deleted from the category list
                updatedSubgroups = [
                  ...updatedSubgroups,
                  ...reportDataSetService.getFilterOptionLabels(block).filter((field) => field.isSplitChartFilter)
                ]
                block = reportDataSetService.updateFilterOptionLabels(block, updatedSubgroups)
                pageEditorContext.registerUnsavedChanges()
                pageEditorContext.updateCurrentEdit({ block: { ...block } })
              }}
            />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  )
}
